<div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img
        class="d-block w-100"
        src="../../assets/cover1.jpeg"
        alt="First slide"
      />
    </div>
    <div class="carousel-item">
      <img
        class="d-block w-100"
        src="../../assets/WhatsApp Image 2025-05-17 at 2.47.15 AM.jpeg"
        alt="Second slide"
      />
    </div>
    <div class="carousel-item">
      <img
        class="d-block w-100"
        src="../../assets/WhatsApp Image 2025-05-17 at 3.30.28 AM.jpeg"
        alt="Third slide"
      />
    </div>
  </div>
  <a
    class="carousel-control-prev"
    href="#carouselExampleControls"
    role="button"
    data-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a
    class="carousel-control-next"
    href="#carouselExampleControls"
    role="button"
    data-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
<div class="container">
  <div class="row mt-5">
    <div class="col-md-3 col-sm-6">
      <div
        class="card d-flex ustify-content-center font-weight-bold text-light border"
      >
        <div
          class="card"
          style="
            background-color: #ce6a85;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
              0 6px 20px 0 rgba(0, 0, 0, 0.19);
            background-size: cover;
          "
        >
          <ul class="list-group list-group-flush m-2 mt-1 text-dark">
            <li class="card list-group-item mb-3 mt-3 text-dark bg-light">
              <a
                [routerLink]="['/Complain-reg']"
                routerLinkActive="active"
                class="text-dark h7"
                ><i
                  class="fa fa-hand-o-right mr-3 text-danger"
                  aria-hidden="true"
                ></i
                >Complain Register</a
              >
            </li>
            <li class="card list-group-item mb-3 bg-light $zindex-modal:1060;">
              <a
                class="text-dark h7"
                [routerLink]="['/Complain-status']"
                routerLinkActive="active"
                ><i class="fa fa-hand-o-right mr-3 text-success"></i>Complain
                Status</a
              >
            </li>

            <li class="card list-group-item mb-3 bg-light">
              <i class="bi bi-star-fill fa-spin mr-3"></i>Online Apply
            </li>

            <li class="card list-group-item mb-3 bg-light">
              <i class="bi bi-star-fill fa-spin mr-3"></i>Online Apply
            </li>
            <li class="card list-group-item mb-3 bg-light">
              <i class="bi bi-star-fill mr-3"></i>Online Apply
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-md-5 col-sm-6">
      <h2 class="text-center">Notices & Events</h2>
      <ul class="shadow list-group d-flex">
        <!-- <li class="list-group-item"><h2>Recent</h2></li> -->

        <marquee behavior="scroll" direction="up" scrollamount="2">
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >event</i
              >Hon. Chief minister will inaugurate Kalinga Setu on 5/02/21 |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
        </marquee>
      </ul>
    </div>

    <div class="col-md-4 col-sm-12">
      <h2 class="text-center">Leader</h2>
      <div class="shadow-lg p-2 card">
        <div class="card text-dark mb-3 mt-2">
          <div class="card-header d-flex justify-content-center">
            <div class="avatar mx-auto pt-3 pb-3">
              <img
                src="../../assets/Sarpanch.png"
                class="rounded-circle z-depth-1 d-flex justify-content-center"
                style="width: 8rem"
                alt="Sample avatar"
              />
            </div>
          </div>
          <h2 class="card-title d-flex justify-content-center pt-3">
            Mr. Tapas Kumar Das
          </h2>
          <p class="card-text text-center pb-3">SARAPANCH</p>
        </div>

        <div class="card mb-2">
          <div class="card-header">
            <div class="avatar mx-auto d-flex justify-content-center pt-3 pb-3">
              <img
                src="../../assets/WhatsApp Image 2025-05-16 at 3.33.22 AM (1).jpeg"
                class="rounded-circle z-depth-1"
                style="width: 8rem"
                alt="Sample avatar"
              />
            </div>
          </div>

          <h2 class="card-title d-flex justify-content-centerpt-3">
            Mr. Prasanna Mohanty
          </h2>
          <p class="card-text text-center pb-3">PANCHAYAT EXECUTIVE OFFICER</p>
        </div>
      </div>
    </div>
  </div>
  <!-- < end about panchayat> -->
</div>

<!-- counter -->
<div class="container my-5">
  <!--Section: Content-->
  <section class="p-5 z-depth-1">
    <h2 class="text-center text-success font-weight-bold mb-5">
      Population Counter
    </h2>

    <div class="shadow row d-flex p-5 bg-light justify-content-center">
      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 bi bi-people text-success"></i>
          <span
            class="d-inline-block count-up"
            data-from="0"
            data-to="100"
            data-time="2000"
            >760</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Population</p>
      </div>

      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 text-success fa fa-male" aria-hidden="true"></i>
          <span
            class="d-inline-block count2"
            data-from="0"
            data-to="330"
            data-time="2000"
            >330</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Men</p>
      </div>

      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 text-success fa fa-female" aria-hidden="true"></i>
          <span
            class="d-inline-block count3"
            data-from="0"
            data-to="430"
            data-time="2000"
            >430</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Women</p>
      </div>

      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 bi bi-building text-success"></i>
          <span
            class="d-inline-block count1"
            data-from="0"
            data-to="250"
            data-time="2000"
            >365</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Houses</p>
      </div>
      <i
        class="h1 fa fa-chevron-circle-right text-success"
        aria-hidden="true"
      ></i>
    </div>
  </section>
  <!--Section: Content-->
</div>
<!-- end counter -->

<!-- < start team> -->

<div class="container pt-5 my-5">
  <!--Section: Content-->
  <section class="team-section text-center dark-grey-text">
    <!-- Section heading -->
    <h2 class="font-weight-bold pb-2 mb-4 text-success">
      Programmes & Schemes
    </h2>
    <!-- Section description -->
    <!-- <p class="text-muted w-responsive mx-auto mb-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Fugit, error amet numquam iure provident voluptate esse quasi, veritatis totam voluptas nostrum quisquam
        eum porro a pariatur veniam.</p> -->

    <!-- Grid row -->

    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div class="col">
        <div class="card shadow">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRX4ed8b7agQVUEUJSIAlndkkbexlydZL07mQ&usqp=CAU"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <h2 class="card-title text-success">Rural Housing</h2>
            <p class="card-text">details</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card shadow">
          <video width="350" height="230" controls>
            <source
              src="../../assets/video/VID-20250826-WA0000.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div class="card-body">
            <h2 class="card-title text-success">Independence Day</h2>
            <p class="card-text">details</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card shadow">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRX4ed8b7agQVUEUJSIAlndkkbexlydZL07mQ&usqp=CAU"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <h2 class="card-title text-success">Rural Housing</h2>
            <p class="card-text">details</p>
          </div>
        </div>
      </div>
    </div>

    <i
      class="h1 fa fa-chevron-circle-right text-success"
      aria-hidden="true"
    ></i>

    <!-- Grid row -->
  </section>
  <!--Section: Content-->
</div>

<!-- <end team> -->

<div class="container my-5 py-5 z-depth-1">
  <!--Grid row-->
  <div class="row d-flex justify-content-center mt-10">
    <!--Grid column-->
    <div class="col-md-6 text-center">
      <h2 class="font-weight-bold text-success">Gallery</h2>

      <!-- <p class="text-muted">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam sapiente
      molestiae.</p> -->
    </div>
    <!--Grid column-->
  </div>
  <!--Grid row-->

  <div class="row">
    <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
      <img
        src="../../assets/newPhoto6.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />

      <img
        src="../../assets/newPhoto3.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />
    </div>

    <div class="col-lg-4 mb-4 mb-lg-0">
      <img
        src="../../assets/newPhoto8.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />

      <img
        src="../../assets/newPhoto4.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />
    </div>

    <div class="col-lg-4 mb-4 mb-lg-0">
      <img
        src="../../assets/newPhoto5.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />

      <img
        src="../../assets/WhatsApp Image 2025-05-17 at 2.47.16 AM.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />
    </div>
  </div>
  <button type="button" class="btn btn-outline-success float-right">
    more images
  </button>
</div>

<!-- Gallery -->

<div class="container my-5 py-5 z-depth-1">
  <!--Section: Content-->
  <section class="px-md-5 mx-md-5 text-center text-lg-left dark-grey-text">
    <style>
      .map-container {
        height: 230px;
        position: relative;
      }

      .map-container iframe {
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        position: absolute;
      }
    </style>

    <!--Grid row-->
    <div class="row d-flex justify-content-center">
      <!--Grid column-->
      <div class="col-md-6 text-center">
        <h2 class="font-weight-bold text-success">Contact Us</h2>

        <p class="text-muted">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam
          sapiente molestiae.
        </p>
      </div>
      <!--Grid column-->
    </div>
    <!--Grid row-->

    <!--Grid row-->
    <div class="row">
      <!--Grid column-->
      <div class="col-lg-6 col-md-12 mb-4 mb-md-0">
        <!-- Material outline input -->
        <div class="md-form md-outline mt-3">
          <input type="email" id="form-email" class="form-control" />
          <label for="form-email">E-mail</label>
        </div>

        <!-- Material outline input -->
        <div class="md-form md-outline">
          <input type="text" id="form-subject" class="form-control" />
          <label for="form-subject">Subject</label>
        </div>

        <!--Material textarea-->
        <div class="md-form md-outline mb-3">
          <textarea
            id="form-message"
            class="md-textarea form-control"
            rows="3"
          ></textarea>
          <label for="form-message">How we can help?</label>
        </div>

        <button type="submit" class="btn btn-success btn-sm ml-0">
          Submit<i class="far fa-paper-plane ml-2"></i>
        </button>
      </div>
      <!--Grid column-->

      <!--Grid column-->
      <div class="col-lg-6 col-md-12 mb-0 mb-md-0">
        <video width="520" height="270" controls>
          <source
            src="../../assets/video/WhatsApp Video 2025-06-19 at 2.44.40 AM.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <!--Google map-->
        <!-- <div id="map-container-google-1" class="z-depth-1 map-container mb-4">
          <iframe
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDD4T6QfZREyEe-69DsyyBRJTCjyiYdzUs&q=Ranipokhari+Mayurbhanj+Odisha+India&maptype=satellite&zoom=18"
            frameborder="0"
            style="border: 0"
            allowfullscreen
          ></iframe>
        </div> -->
        <!--Google Maps-->

        <p class="font-weight-bold">Pokharia ,Odisha 757079</p>
      </div>
      <!--Grid column-->
    </div>
    <!--Grid row-->
  </section>
  <!--Section: Content-->
</div>
